import { isChromeExtension, isIOS, isNativeApp } from "@/platform/runtime.js";

const openExternalUrl = (
  url,
  { inAppBrowser = false, system = false } = {}
) => {
  if (isChromeExtension() && window.chrome && window.chrome.tabs) {
    return window.chrome.tabs.create({ url });
  }

  if (isNativeApp() && inAppBrowser) {
    const browser = window.cordova && window.cordova.InAppBrowser;
    if (browser) {
      let options = "location=no,clearcache=yes";
      if (isIOS()) {
        options +=
          ",toolbarcolor=#ffffff,toolbarposition=top,closebuttoncaption=Fechar";
      }
      return browser.open(url, system ? "_system" : "_blank", options);
    }
  }

  return window.open(url);
};

export { openExternalUrl };
